<template>
    <loading-spinner v-if="loading"/>
    <div v-else-if="program" style="padding-bottom: 100px">

        <back-button/>

        <!-- BUTTON ASSIGN -->
        <v-row :class="{'mt-12': !isMobile}">
            <v-col cols="4" offset="8" class="text-right">
                <div :class="isMobile ? 'container-bottom-button' : 'container-top-button'">
                    <div class="bottom-row">
                        <v-btn @click="assignProgram" color="primary" class="black--text bottom-button" block depressed
                               large>
                            {{ $t('programs.assign_program') }}
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <!-- IMG AND NAME LEFT -->
            <v-col cols="12" md="6" class="pa-3">
                <div class="program-name">
                    {{ program.name }}
                </div>
                <div class="created_by">
                    {{ $t('common.created_by', {name: programCreator}) }}
                </div>
                <v-img
                    eager max-height="250"
                    contain :class="isMobile ? 'img-profile' : ''"
                    :lazy-src="imgPlaceholder" :src="programImg"
                />
            </v-col>

            <!-- INFO RIGHT -->
            <v-col cols="12" md="6" class="pa-2">
                <v-row class="px-3 mt-5 box-title">
                    <v-col cols="4" class="border-right">
                        {{ $tc('common.minutes', 2) }}
                        <div class="box-description text-truncate">
                            {{ programDuration }}
                        </div>
                    </v-col>
                    <v-col cols="4" class="border-right">
                        {{ $t('programs.routines') }}
                        <div class="box-description">
                            {{ routinesQuantity }}
                        </div>
                    </v-col>
                    <v-col cols="4">
                        {{ $t('common.category') }}
                        <div class="box-description">
                            {{ program.category }}
                        </div>
                    </v-col>
                </v-row>
                <v-row class="px-3" v-if="program.description">
                    <v-col cols="12">
                        <h4>{{ $t('common.description') }}:</h4>
                        {{ program.description }}
                    </v-col>
                </v-row>
                <v-row>
                    <!-- DIVIDER -->
                    <v-col cols="12">
                        <v-divider/>
                    </v-col>
                    <!-- CHART -->
                    <v-col cols="12">
                        <div class="program-text bolder">
                            {{ routineOf }}
                        </div>
                        <div class="program-text">
                            {{ $t('common.made_of') }}
                        </div>
                        <pie-chart style="height: 200px" :labels="labels" :datasets="datasets"/>
                    </v-col>
                </v-row>
            </v-col>

            <!-- ROUTINES -->
            <v-col cols="12" class="pa-3">
                <v-divider class="divider-primary"/>
                <program-routines :program-id="programId" :program-img="programImg"
                                  :assigned-routines="assignedRoutines"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {db} from "@/utils/Firebase";
import ProgramRoutines from "@/components/coach/routines/ProgramRoutines";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import BackButton from "@/components/common/BackButton";
import PieChart from "@/components/common/PieChart";
import {getMergedBlocks} from "@/utils/Exercises";

export default {
    name: "ProgramDetail",
    components: {PieChart, BackButton, LoadingSpinner, ProgramRoutines},
    data() {
        return {
            programCreator: '...',
            loading: false,
            program: null,
            datasets: [],
            labels: [],
            colors: ['#99CC00', '#797979', '#2C3149', '#078571', '#66CCCC']
        }
    },
    computed: {
        programId(vm = this) {
            return vm.$route.params.uid || null
        },
        programImg(vm = this) {
            return vm.program?.img || vm.imgPlaceholder
        },
        routinesQuantity(vm = this) {
            return vm.program?.assignedRoutines?.length || 0
        },
        assignedRoutines(vm = this) {
            return vm.program?.assignedRoutines || []
        },
        programDuration(vm = this) {
            let minutes = 0
            vm.assignedRoutines.forEach(routine => {
                routine.blocks.forEach(block => {
                    block.exercises.forEach(exercise => {
                        minutes += exercise?.config?.sets?.length || 0
                    })
                })
            })
            minutes = minutes / vm.routinesQuantity
            let minutesAdded = Number(minutes * 1.3).toFixed()
            if (Number(minutes) === Number(minutesAdded)) return minutes
            return `${minutes} - ${minutesAdded}`
        },
        routineOf(vm = this) {
            if (vm.program?.category) return `${vm.$t('routines.routine_of')} ${vm.program?.category}`
            return vm.$t('common.routine')
        },
    },
    async mounted() {
        const vm = this
        await vm.loadProgram()
        vm.loadProgramChart()
    },
    methods: {
        assignProgram() {
            const vm = this
            let query = {}
            if (vm.$route.query?.studentId) query.studentId = vm.$route.query.studentId
            vm.$router.push({name: 'coach.routines.program.assign', params: {uid: vm.programId}, query: query})
        },
        async loadProgram() {
            const vm = this
            vm.loading = true

            let programRef = await db.collection('programs').doc(vm.programId).get()
            vm.program = programRef.data()

            for (let routine of vm.program.assignedRoutines) {
                routine.blocks = await getMergedBlocks(routine.blocks)
            }

            let userRef = await db.collection('users').doc(vm.program.coachId).get()
            vm.programCreator = userRef.data()?.name || vm.$t('common.not_available_short')

            vm.loading = false
        },
        loadProgramChart() {
            const vm = this
            if (!vm.program) return;
            let data = []
            let labels = []

            vm.program.assignedRoutines.forEach(routine => {
                routine.blocks.forEach(block => {
                    block.exercises.forEach(exercise => {
                        if (exercise.type === 'exercise' && exercise.categories) labels.push(...exercise.categories)
                    })
                })
                vm.labels = [...new Set(labels)]

                routine.blocks.forEach(block => {
                    vm.labels.forEach((label, i) => {
                        if (!data[i]) data[i] = 0
                        data[i] += block.exercises.filter(exercise => exercise.categories?.includes(label)).length || 0
                    })
                })
            })

            vm.datasets = [{
                data: data,
                backgroundColor: vm.colors,
            }]
        }
    },
    watch: {
        program() {
            this.loadProgramChart()
        }
    }
}
</script>

<style scoped>


.container-top-button {
    position: fixed;
    top: 80px;
    right: 30px;
    flex-direction: row;
    display: flex;
    align-items: center;
    z-index: 999;
    background-color: #FFFFFF !important;
}

.divider {
    margin-left: 40%;
    margin-right: 40%;
    color: #c5c5c5;
}

.program-name {
    font-size: 24px;
    line-height: 27px;
    color: #333333;
    font-weight: bold;
}

.created_by {
    font-size: 13px;
    color: var(--v-secondary-base);
    margin-bottom: 4px;
    margin-top: 4px;
}

.box-title {
    font-size: 13px;
    color: #707070;
    text-align: center;
}

.box-description {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
}

.border-right {
    border-right: 1px solid #C5C5C5;
}
.v-divider {
    border-color: #797979;
    border-radius: 4px;
}

.program-text {
    font-weight: 300;
    font-size: 16px;
    line-height: 20px;
    color: #797979;
}

</style>